import API from 'src/api'
import { http } from 'src/boot/axios'

export default {
  URL: API.GRAPHQL_URL + 'user-setting/',
  getSetting (type) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}${type}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  saveSetting ({ type, settings }) {
    const payload = {
      settings
    }

    return new Promise((resolve, reject) => {
      http.post(`${this.URL}${type}`, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }
}
